import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { RIF } from "../../lib";
import { IBatch, IProject } from "../../shared/db";
import { useCreateDispatchActions, useSelectBatchData, useSelectProjectData } from "../../store";
import { DataDownloadContent } from "../organisms";
import { Nullish } from "utility-types";
import { isEmpty } from "lodash";

export const DataDownloadPage = () => {
  const params = useParams();
  const projectId = params["projectId"];

  const { doREQUEST_PROJECT_FETCH, doREQUEST_BATCH_FETCH } = useCreateDispatchActions();

  const navigate = useNavigate();

  const navigateBack = () => {
    navigate(-1);
  };

  const allProjectData = useSelectProjectData();
  const project = (projectId ? allProjectData?.[projectId] : null) as IProject | Nullish;
  const batchId = project?.batchList?.[0]?.id;
  const allBatchData = useSelectBatchData();
  const batchData = (batchId ? allBatchData?.[batchId] : null) as IBatch | Nullish;
  const participantList = batchData?.participantList ?? [];

  useEffect(() => {
    if (!isEmpty(batchData) || !batchId) return;
    doREQUEST_BATCH_FETCH({
      payload: {
        batchId,
      },
    });
  }, [batchData, batchId]);

  useEffect(() => {
    if (!projectId) {
      navigateBack();
      return;
    }
    if (!project) {
      doREQUEST_PROJECT_FETCH({
        payload: {
          projectId,
        },
      });
    }
  }, [projectId, project]);

  return RIF(project, (project) => (
    <DataDownloadContent
      project={project}
      participantList={participantList}
      onClose={() => navigateBack()}
    />
  ));
};
